import { Platform } from "react-native";
import { InputWeb } from "./input-web";
import { InputNative } from "./input-native";
import React from "react";
export var InputVariant;
(function (InputVariant) {
    InputVariant["normal"] = "normal";
    InputVariant["search"] = "search";
})(InputVariant || (InputVariant = {}));
export const Input = Platform.OS === 'web' ? InputWeb : InputNative;
/**
 * Usage:
 * ```
 * const nameInputControl = useInputControl();
 *
 * const onSubmit = React.useCallback(() => {
 *   // consume nameInputControl.value
 * }, [nameInputControl.value]);
 *
 * return (
 *   <Page>
 *     <Input
 *       placeholder="Taylor Doe"
 *       {...nameInputControl.inputProps}
 *     />
 *   </Page>
 * )
 * ```
 *
 * ## Why?
 * This makes input handling smoother as the input remains uncontrolled but still preserves the stateful behavior for external consumers.
 */
export function useInputControl(opts) {
    const inputRef = React.useRef(null);
    const valueRef = React.useRef(opts.defaultValue ?? "");
    const defaultValue = React.useRef(opts.defaultValue ?? '').current;
    const [value, setValue] = React.useState(defaultValue);
    const onChangeValue = React.useCallback((newValue) => {
        valueRef.current = newValue;
        setValue(newValue);
        opts.onChangeValue?.(newValue);
    }, [opts?.onChangeValue]);
    const update = React.useCallback((newValue) => {
        setValue(newValue);
        if (inputRef.current)
            inputRef.current.value = newValue;
    }, []);
    return React.useMemo(() => {
        return {
            value,
            valueRef,
            update,
            inputProps: {
                ref: (el) => {
                    inputRef.current = el;
                },
                value: undefined,
                onChangeValue,
                defaultValue
            }
        };
    }, [value, onChangeValue]);
}
